import Lottie from 'lottie-react';

import lottieHospital from '../jsons/hospital.json';

const LottieHospital = props => {
  return <Lottie animationData={lottieHospital} loop={false} {...props} />;
};

export default LottieHospital;
